export class PriceTier {
    public static NEWDST = "NEWDST";
    public static WHLSAL = "WHLSAL";
}

export enum StorerPiceTier {
    RETAIL = 1,
    NEWDST = 2,
    WHLD05 = 3,
    WHLD08 = 4,
    WHLD13 = 5,
    WHLD18 = 6,
    WHLSAL = 7,
    RTLD5 = 9,
    RTLD10 = 10,
    RTLD15 = 11,
    WHLD00 = 12
}


// WEBPACK FOOTER //
// ./src/app/customerservice/constants/pricetier.constants.ts